<mr-field-container
  #container
  [customFieldId]="fieldId"
  [label]="label"
  [description]="description"
  [labelHidden]="isLabelHidden"
  [errorsHidden]="areErrorsHidden"
  [additionalErrorMessageTemplate]="errorMessages"
>
  <ngb-timepicker
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [meridian]="true"
    [minuteStep]="minuteStepInMinutes"
    [hourStep]="1"
    [spinners]="!hideSpinners"
  ></ngb-timepicker>
</mr-field-container>

<ng-template #errorMessages let-errors let-errorLabel="errorLabel">
  @if (errors.emptyHour) {
    <li>{{ errorLabel }} must specify hour and minute together</li>
  }
  @if (errors.earliestTimeOfDay; as error) {
    <li>
      @if (error.exact) {
        {{ errorLabel }} must be {{ error.earliest | timeOfDay }}
      } @else {
        {{ errorLabel }} must be equal to or later than
        {{ error.earliest | timeOfDay }}
      }
    </li>
  }
</ng-template>
